import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { APP_CONFIG } from '../environments/environment.injection.token';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(), 
    provideHttpClient(),
    {
      provide: APP_CONFIG, useValue: environment
    }
  ]
};
